// extracted by mini-css-extract-plugin
module.exports = {"articleGridSkeleton":"article-grid-skeleton_articleGridSkeleton__2q0XE"};